// imports
import Component from 'minsky-kit/js/components/Component';
import PageNav from './PageNav';
import SectionTracker from './SectionTracker';

// private statics
const VERSION = '1.0.0';

// class definition
export default class Tab extends Component {
    // constructor
    constructor (args = {}, objectName = 'Tab') {
        args.debug = args.debug || false;
        args.states = [
            {
                name:      'show',
                immediate: false,
                steps:     [
                    {
                        name:        'showing',
                        removeClass: ['tab--state-hidden', 'tab--state-hiding'],
                        addClass:    ['tab--state-showing'],
                        duration:    500,
                    },
                    {
                        name:        'shown',
                        removeClass: ['tab--state-showing'],
                        addClass:    ['shown'],
                        duration:    0,
                    },
                ],
            },
            {
                name:      'hide',
                immediate: false,
                steps:     [
                    {
                        name:        'hiding',
                        removeClass: ['tab--state-shown'],
                        addClass:    ['tab--state-hiding'],
                        duration:    0,
                    },
                    {
                        name:        'hidden',
                        removeClass: ['tab--state-hiding'],
                        addClass:    ['tab--state-hidden'],
                        duration:    500,
                    },
                ],
            },
        ];
        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        // super destroy
        this.states.allClasses.forEach((c) => {
            this.el.classList.remove(c);
        });

        super.destroy();
    }

    show () {
        this.states.set('show');
    }

    hide () {
        this.states.set('hide');
    }

    // getters & setters
    static get version () { return VERSION; }
}

// Utils

// Event handlers
